import * as actionTypes from '../../actionTypes'
import TerminalInfo from '../../data/TerminalInfo'

export default function (state = new TerminalInfo(), action) {
    switch (action.type) {
        case actionTypes.PAYMENT_TERMINAL_CONNECT:
        case actionTypes.PAYMENT_TERMINAL_CONNECTED:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECT:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECTED:
            return new TerminalInfo()
        case actionTypes.PAYMENT_TERMINAL_INFO_RECEIVED:
            return action.terminalInfo
    }

    return state
}
